import { useCallback, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { PAGE } from "src/constants/searchParams";

export const usePlansFilter = (
  key: string,
  defaultValue?: string
): [string, (value: string) => void] => {
  const [params, setSearchParams] = useSearchParams();

  const filter = params.get(key) ?? "";

  const setFilter = useCallback(
    (value: string) => {
      params.set(key, value);
      params.set(PAGE, "0");

      if (value.length === 0) {
        params.delete(key);
      }

      setSearchParams(params);
    },
    [key, params, setSearchParams]
  );

  useEffect(() => {
    if (params.get(key) == null && defaultValue != null) {
      setFilter(defaultValue);
    }
  }, [defaultValue, filter, key, params, setFilter]);

  return useMemo(() => {
    return [filter, setFilter];
  }, [filter, setFilter]);
};
